module.exports = __webpack_public_path__ + "static/media/devtube.86cf5fa0.gif";